import clsx from "clsx";
import { useTheme } from "@mui/material";
import { ProgressBar } from "@/components/Core/CircularProgress/CircularProgress";
import styles from "./SuccessRateInfo.module.scss";
import { useTranslation } from "next-i18next";

export const SuccessRateInfo = ({
    total,
    success,
    themeColor,
}: {
    total?: number;
    success?: number;
    themeColor?: "dark" | "light";
}) => {
    const { palette } = useTheme();
    const { t } = useTranslation("common");
    const _themeColor = themeColor || palette.mode;
    const successRate = total && success ? (success / total) * 100 : 0;

    return (
        <div className={styles.successRate}>
            <div className={styles.rateDetails}>
                <span className={clsx(styles.row, styles.title)}>
                    {t("analytics.analystForecasts.successRate.title")}
                </span>
                <span className={styles.row}>
                    {t("analytics.analystForecasts.successRate.summary", {
                        success: success ?? "--",
                        total: total ?? "--",
                    })}
                </span>
                <span className={styles.row}>
                    {t("analytics.analystForecasts.successRate.caption")}
                </span>
            </div>
            <div className={styles.ratePersentage}>
                <ProgressBar
                    value={successRate}
                    size={48}
                    thickness={5}
                    fontSize="15px"
                    bgColor={_themeColor === "dark" ? "#15171C" : "#E6ECF1"}
                    themecolor={_themeColor}
                    fillColor={successRate >= 50 ? "success" : "error"}
                />
            </div>
        </div>
    );
};
